<template>
  <div>
    <p class="title">
      <span v-html="surveyQuestion.longCaption" />
    </p>
    <sanitas-button primary @click="handleClose">
      {{ texts.close }}
    </sanitas-button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SanitasButton from '../../common/SanitasButton'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Finished',
  components: {
    SanitasButton,
  },
  computed: {
    ...mapGetters(['texts', 'surveyQuestion']),
  },
  methods: {
    ...mapActions(['closeSurvey']),
    handleClose() {
      this.$emit('close')
      this.closeSurvey()
    },
  },
}
</script>

<style scoped lang="postcss">
@media (max-width: 768px) {
  .title {
    padding-bottom: 10px;
    font-size: 16px;
    line-height: 20px;
  }
}

@media (min-width: 768px) {
  .title {
    padding-bottom: 30px;
    font-size: 25px;
    line-height: 1.2;
  }
}
</style>
